<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item >首页</el-breadcrumb-item>
            <el-breadcrumb-item style="margin-bottom:20px">宣传页管理</el-breadcrumb-item>
        </el-breadcrumb>
        <div>
            <el-form label-width="120px" :model="leafletsForm" :rules="rules" ref="editForm">
                <el-form-item label="页面地址" prop="codeaddr">
                <el-input size="small" style="width:300px" v-model="leafletsForm.codeaddr" auto-complete="off" placeholder="页面地址"></el-input>
                </el-form-item>
                <el-form-item label="添加视频地址" prop="videourl">
                <el-input size="small" style="width:300px" v-model="leafletsForm.videourl" auto-complete="off" placeholder="添加视频地址"></el-input>
                </el-form-item>
                <el-form-item label="分享文案" prop="content">
                <el-input size="small" style="width:300px" v-model="leafletsForm.content" auto-complete="off" placeholder="页面地址"></el-input>
                </el-form-item>
                <el-form-item label="分享图片" prop="pic" >
                    <img style="width:150px;height:80px" v-if="leafletsForm.pic != null" :src="leafletsForm.pic" alt="">
                    <el-upload
                        :http-request="videoHandleChange"
                        :file-list="videoFileList"
                        accept=".jpg , .png ,"
                        >
                        <el-button size="small" type="primary">点击上传</el-button>
                        <!-- <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
                    </el-upload>
                </el-form-item>
            </el-form>
        </div>
        <el-button size="small" type="primary" :loading="loading" v-preventReClick style="margin-left:150px" @click="submitForm('editForm')">保存</el-button>
    </div>
</template>
<script>
import VideoPlay from '../video.vue'
import Pagination from '../../components/Pagination'
import { pubpageList , pubpageAdd} from '../../api/userMG'
export default {
    data(){
        return{
            leafletsForm:{},
            rules: {
                codeaddr : [
                { required: true, message: '请输入页面地址', trigger: 'blur' }
                ],
                content : [
                { required: true, message: '请输入分享文案', trigger: 'blur' }
                ],
                videourl : [
                { required: true, message: '请输入视频地址', trigger: 'blur' }
                ],
            }
        }
    },
    components: {
        Pagination,
        VideoPlay
    },
    created(){
        this.getdata()
        console.log(this.queryUrl)
    },
    methods:{
        videoClick(row){
                this.videoUrl = row
                this.videoFlag = true
        },
        subFun(e){
            pubpageAdd({
                pic:e,
                videourl:this.leafletsForm.videourl,
                codeaddr:this.leafletsForm.codeaddr,
                content:this.leafletsForm.content,
                id:this.leafletsForm.id
            }).then(AddRes=>{
                if(!AddRes.success){
                    this.$message.error(AddRes.message)
                }else {
                    this.$message.success('保存成功')
                    this.getdata()
                }
            })
},
        // 新建提交
        submitForm(editData){
            this.$refs[editData].validate(valid => {
                if (valid) {
                    let formData = new FormData()
                    if(this.videoFileList[0] == undefined){
                        this.subFun(this.leafletsForm.pic)
                        return
                    }
                    formData.append('file' , this.videoFileList[0])
                    this.$axios({
                        method: "POST",
                        url: "/yunyue-houtai/file/upload",
                        headers: {
                            "Content-Type": "multipart/form-data",
                            token: localStorage.getItem("logintoken"),//token值，根据接口要求传或者不传
                        },
                        data: formData,
                    }).then(res=>{
                        console.log(res.data.data)
                        if(res.data.success == true){
                            this.subFun(res.data.data)
                        }else {
                            this.$message.error(res.data.messages)
                        }
                        
                    })
                } else {
                    return false
                }
            })
        },
        // 删除
        delInfomercial(index , row){
            this.$confirm('是否确认删除', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 删除
                videoDel(row.id).then(res => {
                        if (res.success) {
                            this.$message({
                            type: 'success',
                            message: '操作成功!'
                            })
                            this.getdata()
                        } else {
                            this.$message({
                            type: 'info',
                            message: res.message
                            })
                        }
                    })
                    .catch(err => {
                        this.loading = false
                        this.$message.error('操作失败，请稍后再试！')
                    })
                })
            .catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除！'
                })
            })
        },
        handleChange(file){
            console.log(file)
            this.fileList = [file.file] 
            console.log(this.fileList)
        },
        videoHandleChange(file){
            console.log(file)
            this.videoFileList = [file.file] 
            console.log(this.videoFileList)
        },
        closeDialog(){
            this.editFormVisible = false
        },
        addBanner(){
            this.editFormVisible = true
            this.fileList = []
            this.videoFileList = []
            this.editForm = {
                type:1,
                status:'1'
            }
        },
        getdata(){
            pubpageList().then(res=>{
                this.leafletsForm = res.data[0] == undefined?{}:res.data[0]
            })
        },
        // 分页插件事件
        callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.limit = parm.pageSize
            this.getdata(this.formInline)
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/views/system/leaflets.vue